<template>
  <div class="modal fade confirm" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close"
            ><i class="icon-close"></i
          ></a>
          <h3 class="modal-title">公司合併查詢</h3>
        </div>
        <div class="modal-body">
          <table id="merge-table" class="table insurance-green">
            <thead>
              <tr>
                <th width="50%" class="text-center">公司名稱</th>
                <th width="50%" class="text-center">合併或更名後公司名稱</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in mergeList" :key="`merge-item-${i}`">
                <td class="text-center">{{ item.from }}</td>
                <td class="text-center">
                  <span class="arrow text-red">❯</span>
                  {{ item.to }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyMergeModal",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mergeList: [
        {
          from: "喬治亞、安泰",
          to: "富邦人壽",
        },
        {
          from: "蘇黎世人壽",
          to: "遠雄人壽",
        },
        {
          from: "佳迪福人壽",
          to: "法國巴黎人壽",
        },
        {
          from: "中央信託局",
          to: "臺銀人壽",
        },
        {
          from: "統一安聯、匯豐",
          to: "安聯人壽",
        },
        {
          from: "第一、慶豐",
          to: "保誠人壽",
        },
        {
          from: "中興人壽",
          to: "遠雄人壽",
        },
        {
          from: "宏福人壽",
          to: "宏泰人壽",
        },
        {
          from: "美國人壽",
          to: "友邦人壽",
        },
        {
          from: "興農、朝陽人壽",
          to: "南山人壽",
        },
        {
          from: "大都會、宏利、中國信託",
          to: "台灣人壽",
        },
        {
          from: "紐約人壽",
          to: "元大人壽",
        },
        {
          from: "國華、全美、國衛、美國家庭人壽",
          to: "全球人壽",
        },
        {
          from: "瑞泰、中國人壽",
          to: "凱基人壽",
        },
        {
          from: "康健、安達、中泰人壽",
          to: "安達國際人壽",
        },
        {
          from: "保德信、台新人壽",
          to: "新光人壽",
        }
      ],
    };
  },
  methods: {},
  mounted() {},
};
</script>
